import { createAction, props } from "@ngrx/store";
import { ICategory } from "../models/categories.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// fetch all categories
export const FetchAllCategories = createAction(
  '[ Categories ] - FetchAllCategories',
  props<{ includes?: Array<string> }>()
);
export const FetchAllCategoriesSuccess = createAction(
  '[ Categories ] - FetchAllCategories Success ',
  props<{ categories: APIResponse<ICategory> }>()
);
export const FetchAllCategoriesError = createAction(
  '[ Categories ] - FetchAllCategories Error',
);

// fetch categories
export const FetchCategories = createAction(
  '[ Categories ] - FetchCategories',
  props<{ page: IPageCount, key?: string | undefined;}>()
);
export const FetchCategoriesSuccess = createAction(
  '[ Categories ] - FetchCategories Success ',
  props<{ categories: APIResponse<ICategory> }>()
);
export const FetchCategoriesError = createAction(
  '[ Categories ] - FetchCategories Error',
);

// add categories
export const AddCategory = createAction(
  '[ Categories ] - AddCategory',
  props<{ category: Omit<ICategory, 'id'>  }>()
);
export const AddCategorySuccess = createAction(
  '[ Categories ] - AddCategory Success ',
  props<{ categories: Array<ICategory> }>()
);
export const AddCategoryError = createAction(
  '[ Categories ] - AddCategory Error',
);

//update categories
export const UpdateCategory = createAction(
  '[ Categories ] - UpdateCategory',
  props<{ id: number, category: Omit<ICategory, 'id'> }>()
);
export const UpdateCategorySuccess = createAction(
  '[ Categories ] - UpdateCategory Success ',
  props<{ category: ICategory }>()
);
export const UpdateCategoryError = createAction(
  '[ Categories ] - UpdateCategory Error',
);

//Delete categories
export const DeleteCategory = createAction(
  '[ Categories ] - DeleteCategory',
  props<{ id: number }>()
);
export const DeleteCategorySuccess = createAction(
  '[ Categories ] - DeleteCategory Success ',
);
export const DeleteCategoryError = createAction(
  '[ Categories ] - DeleteCategory Error',
);


// looder actions
export const SetCategoriesLoader = createAction(
  '[ Categories ] - SetLoading',
  props<{ isLoading: boolean }>()
)

// search
export const SetCategoriesSearch = createAction(
  '[ Search ] - SetCategoriesSearch',
  props<{ keyword: string }>()
);
